import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EventNavigation, NavigationItem } from "@mv/submodules/ui/packages/navigation/src/model";
import { BankDetailsGuard } from "@modules/dashboard/bankDetails/bankDetails.guard";
import { BehaviorSubject, Observable } from "rxjs";
import { IsTierListService } from "./IsTierList.service";
import { ContractDataService } from "./contractData.service";
import { IsContractData } from "@models/interfaces";
import { ListSharingGuard } from "@modules/dashboard/listSharing/listSharing.guard";

@Injectable()
export class NavigationService {
    private readonly _inMenu: BehaviorSubject<string> = new BehaviorSubject("");
    public inMenu$: Observable<string> = this._inMenu.asObservable();
    private _isPotOption: boolean;
    private _isTierList: boolean;
    private _isValidDate: boolean;

    private _initMenuData: string = `[
    { "icon": "mv-icons--design--account",  "item": "Coordonnées", "route":"/ma-liste/coordonnees"},
    { "icon": "mv-icons--design--flight" ,  "item": "Voyage", "isActive":true ,"route":"/ma-liste/voyage"},
    { "icon": "mv-icons--design--documents" ,  "item": "Contrat", "isActive":true,"route":"/ma-liste/contrat" },
    { "icon": "mv-icons--design--users" ,  "item": "Partages","route":"/ma-liste/partages"},
    { "icon": "mv-icons--design--payment" ,  "item": "RIB","route":"/ma-liste/rib" },
    { "icon": "mv-icons--design--loyalty_program" ,  "item": "Offrir","route":"/ma-liste/offrir-liste" }
    ]`;

    constructor(
        private _router: Router,
        private _bankDetailsGuard: BankDetailsGuard,
        private _isTierListService: IsTierListService,
        private _contractDataService: ContractDataService,
        private _listSharingGuard: ListSharingGuard,
    ) {
        this._bankDetailsGuard.isPotOption$.subscribe((isPotOption) => {
            this._isPotOption = isPotOption;
            this._initMenu();
        });

        this._router.events.subscribe(() => {
            this._initMenu();
        });

        this._isTierListService.isTierList$.subscribe((datas: boolean) => {
            this._isTierList = !datas;
            this._initMenu();
        });
        this._contractDataService.isContractData$.subscribe((datas: IsContractData) => {
            this._isValidDate = datas.isValidContract;
            this._initMenu();
        });
    }

    public onClickMenu(event: EventNavigation): void {
        const path: string = event.detail.route;
        this._router.navigate([path]).then(() => {});
    }

    private _initMenu(): void {
        const copyMenu: NavigationItem[] = JSON.parse(this._initMenuData);
        let modifMenu = copyMenu.map((element: NavigationItem): NavigationItem => {
            let itemMenu: NavigationItem =
                element.route === this._router.url ? { ...element, isActive: true } : { ...element, isActive: false };

            if (element.item === "Partages") {
                itemMenu = { ...element, isDisable: !this._isValidDate };
                this._listSharingGuard.toggleValidationdate(this._isValidDate);
            }
            return itemMenu;
        });

        if (!this._isPotOption) {
            modifMenu = modifMenu.filter((val) => val.route != "/ma-liste/rib");
        }

        if (this._isTierList || !this._isValidDate) {
            modifMenu = modifMenu.filter((val) => val.route != "/ma-liste/offrir-liste");
        }

        this._inMenu.next(JSON.stringify(modifMenu));
    }
}
